import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import api from "../../lib/api";

/**
 * RelatedTreatments — pulls Expertise pages by slug and renders horizontal cards.
 * Provide `slugs = [...]` (from `related_expertise` field on blog/hub).
 */
const RelatedTreatments = ({ slugs }) => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (!slugs?.length) return;
    Promise.all(slugs.map((s) => api.get(`/expertise/${s}`).then((r) => r.data).catch(() => null)))
      .then((rs) => setItems(rs.filter(Boolean)));
  }, [JSON.stringify(slugs)]); // eslint-disable-line

  if (items.length === 0) return null;

  return (
    <section className="not-prose mt-14" data-testid="related-treatments">
      <div className="text-[10px] uppercase tracking-[0.28em] text-[hsl(var(--accent))] mb-4">Related treatments at our clinic</div>
      <h3 className="font-serif text-2xl sm:text-3xl">Treatments Dr. Shantanu offers for this</h3>
      <div className="h-[2px] w-12 bg-[hsl(var(--accent))] mt-3 mb-6" />
      <div className="grid sm:grid-cols-2 gap-4">
        {items.map((e) => (
          <Link
            key={e.slug}
            to={`/expertise/${e.slug}`}
            data-testid={`related-treatment-${e.slug}`}
            className="group border border-border rounded-xl p-5 hover:border-[hsl(var(--primary))] transition-colors flex items-start gap-4"
          >
            <div className="flex-1">
              <div className="font-serif text-lg leading-snug group-hover:text-[hsl(var(--primary))]">{e.title}</div>
              <p className="mt-1.5 text-sm text-muted-foreground line-clamp-2">{e.tagline}</p>
            </div>
            <ArrowUpRight size={18} strokeWidth={1.5} className="text-[hsl(var(--accent))] mt-1 shrink-0 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </Link>
        ))}
      </div>
    </section>
  );
};

export default RelatedTreatments;
